module.exports = __webpack_public_path__ + "static/img/2.7f13958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/8/2.png
// module id = +uBx
// module chunks = 1